export const CHANNEL_DETAIL_SUB_KEYS = {
  EMAIL: "email",
  DIGITAL: "digital",
  BOTH: "both",
  AFFINITY: "affinity",
  HISTORY: "history",
} as const;

export const CHANNEL_DETAIL_HISTORY_MONTHS = 6;
